import BaseApi from './baseApi';
import IListStatusSell from '../models/IListStatusSell';
import IAuthentication from '../models/IAuthentication';
export default class ListStatusSellsApi extends BaseApi {
    idUser : string = "";
    idCompany : string = "";
    constructor() {
        super("dataaccess", "Settings");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
        this.idCompany = userFromStorage.idCompany;
    }

    async GetListStatusSell() : Promise<IListStatusSell[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var listStatusSell: IListStatusSell[] = [];
            listStatusSell = response.data as IListStatusSell[];
            return listStatusSell;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveListStatusSell(listStatusSell: IListStatusSell) : Promise<string> {
        const json = this.getJsonSave(listStatusSell);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateListStatusSell(listStatusSell: IListStatusSell) : Promise<boolean> {
        const json = this.getJsonUpdate(listStatusSell);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteListStatusSell(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async inUseSetting(id: string) : Promise<boolean> {
        const json = this.getInUseJson(id);
        const response = await this.api.post('ExecWithResults', json);
        if (!response) return false;
        if (response.isSuccess) {
            const data = response.data as any[];
            return Number(data && data[0] && data[0].isInUse) === 1;
        } else {
            this.modelState = response.errorState;
            return false;
        }
    }

    private getInUseJson(id: string) : any {
        const json = {
            "spname": "dbo.IS_STATUS_SELL_IN_USE",
            "parameters": [{
                "Item1": "StatusSellId ",
                "Item2": id
            }, {
                "Item1": "companyId ",
                "Item2": this.idCompany
            }]
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "ListStatusSell",
                "Item2": "id"
            }, {
                "Item1": "ListStatusSell",
                "Item2": "name"
            }, {
                "Item1": "ListStatusSell",
                "Item2": "idCompany"
            }],
            "tables": [{
                "Item1": "ListStatusSell"
            }],
            "conditions": [{
                "Item1": "ListStatusSell",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "ListStatusSell",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": this.idCompany
            }],
            "orderBy": [{
                "Item1": "ListStatusSell.name"
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "ListStatusSell",
            "conditions": [{
                "Item1": "ListStatusSell",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(listStatusSell: IListStatusSell) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listStatusSell.name
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "idCompany",
                "Item2": this.idCompany
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "ListStatusSell"
        };
        return json;
    }

    private getJsonUpdate(listStatusSell: IListStatusSell) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listStatusSell.name
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "ListStatusSell",
            "keyvalue": listStatusSell.id
        };
        return json;
    }
}
